export const openStaffingProfile = (staffingId: string) => {
    const win = window.open(`https://staffing.quantori.com/employee/${staffingId}`, '_blank')
    if (win) win.focus()
}
